import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';
import { Stack } from '@bonusly/design-system';

import { useKeyboardListControl } from '../../hooks/use-keyboard-list-control';
import { useProfilePath } from '../../modules/profile/hooks/use-profile-path';
import { UserCard } from '../../modules/top-navbar/components/User';
import { SearchUser } from '../../queries/search';
import { useSearchContext } from './context';
import { SearchResult } from './SearchResult';
import { toUserType } from './utils';

export const UsersPanel: FC = () => {
	const { users } = useSearchContext();
	const navigate = useNavigate();
	const { isNewProfileEnabled, getProfilePath, getProfileUrl } = useProfilePath();

	const { isSelected, register } = useKeyboardListControl<SearchUser, HTMLAnchorElement>({
		emitClickOnSelect: true,
		focusSelected: true,
		onSelectOption: (user) => {
			if (isNewProfileEnabled) {
				navigate(getProfilePath(user.objectID));
			} else {
				window.location.assign(getProfileUrl(user.objectID));
			}
		},
		options: users,
		selectOnTab: false,
	});

	const { track } = useAnalytics();

	return (
		<Stack as="ul" listStyleType="none">
			{users?.map((user) => {
				const { onClick, ...props } = register(user);

				return (
					<SearchResult
						aria-label={user.display_name}
						isSelected={isSelected(user)}
						key={user.objectID}
						onClick={() => {
							track(AnalyticsEvent.TopNavbar.UserClick);
							onClick();
						}}
						{...props}
					>
						<UserCard user={toUserType(user)} />
					</SearchResult>
				);
			})}
		</Stack>
	);
};
